import { render, staticRenderFns } from "./FeeRate.vue?vue&type=template&id=b2cae546&scoped=true&lang=pug"
import script from "./FeeRate.vue?vue&type=script&lang=js"
export * from "./FeeRate.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "b2cae546",
  null
  
)

export default component.exports